import { useEffect } from 'react';

const useMouseDown = (
  ref,
  onLongPressStart,
  onLongPressEnd,
  onClick,
  timeout = 200
) => {
  useEffect(() => {
    const el = ref.current;
    let isDownDate = null;
    let waitTimeout;

    const listenerUp = (e) => {
      if (new Date() - isDownDate < timeout) {
        clearTimeout(waitTimeout);
        onClick(e);
      } else {
        onLongPressEnd(e);
      }
      isDownDate = null;
      document.removeEventListener('mouseup', listenerUp);
      // el.removeEventListener('touchend', listenerUp);
    };

    const listenerDown = (e) => {
      isDownDate = new Date();
      document.addEventListener('mouseup', listenerUp);
      // el.addEventListener('touchend', listenerUp);
      waitTimeout = setTimeout(() => {
        if (isDownDate) {
          console.log('LongPressStart');
          onLongPressStart(e);
        }
      }, timeout);
    };

    el.addEventListener('mousedown', listenerDown);
    // el.addEventListener('touchstart', listenerDown);

    return () => {
      el.removeEventListener('mousedown', listenerDown);
      // el.removeEventListener('touchstart', listenerDown);
      // el.removeEventListener('touchend', listenerUp);
      document.removeEventListener('mouseup', listenerUp);
      clearTimeout(waitTimeout);
    };
  }, [ref, timeout, onClick, onLongPressStart, onLongPressEnd]);
};

export default useMouseDown;
